import styled from "styled-components";
import { media } from "../../styles/global/theme";

import { Grid, Typography } from "@material-ui/core";

export const PageFirstRow = styled(Grid)`
  padding-top: 24px;

  ${media.greaterThan("sm")`
    padding-top: 40px;
  `};

  // FIX for IE11
  @media all and (-ms-high-contrast: none) {
    & > div {
      height: 84px;
    }
  }
`;

export const Subtitle = styled(Typography)`
  margin-top: 2px;
  font-weight: 600;
  letter-spacing: 0.02em;
  font-size: 18px;
`;

export const Body = styled(Grid)`
  max-width: 768px;
  // NOTE: Important because of MD overide
  margin: 16px auto 0 !important;
  padding-bottom: 16px;
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0px 0px 16px rgba(67, 69, 94, 0.09);

  ${media.greaterThan("sm")`
    // NOTE: Important because of MD overide
    margin: 24px auto 0 !important;
    padding-bottom: 48px;
  `}

  ${media.greaterThan("md")`
    padding-bottom: 48px;
  `}

  ${media.greaterThan("lg")`
    margin: 74px auto 0 !important;
  `}
`;

export const PageLastRow = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
`;

export const FirstPanel = styled(Grid)`
  padding: 0 16px;

  ${media.greaterThan("md")`
    padding: 0 24px;
  `}

  ${media.greaterThan("lg")`
    padding: 0 48px;
  `}
`;

const HeroMediaTopOffset = "30px";

export const HeroMediaContainer = styled.div`
  position: relative;
  width: 100%;
  height: calc(230px - ${HeroMediaTopOffset});
  display: none;

  ${media.greaterThan("md")`
    display: inherit;
    width: 100%;
  `}
`;

export const HeroMedia = styled.div`
  position: absolute;
  top: -${HeroMediaTopOffset};
`;

export const FirstPanelText = styled(Grid)`
  padding-top: 24px;
  // NOTE: Important because of MD overide
  display: none !important;

  ${media.greaterThan("md")`
    // NOTE: Important because of MD overide
    display: inherit !important;
  `}
`;

export const DescriptionContainer = styled.div`
  padding: 24px 16px 0;

  ${media.greaterThan("md")`
    display: none;
  `}
`;

export const FormPanel = styled(Grid)`
  padding: 16px 16px 0;

  ${media.greaterThan("sm")`
    padding: 24px;
  `}

  ${media.greaterThan("md")`
    padding: 48px 24px 0;
  `}

  ${media.greaterThan("lg")`
    padding: 48px 48px 0;
  `}
`;

export const FormLogin = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  margin: 8px 0 0;
  padding: 0;
  width: 100%;

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="number"] {
    -moz-appearance: textfield;
  }
`;

export const InputField = styled(Grid)`
  padding: 0;

  .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #2f80ed;
  }

  .MuiFormControl-root.MuiTextField-root {
    min-height: 79px;
  }
`;

export const Label = styled.label`
  display: block;
  width: 100%;
  font-weight: 600;
  font-size: 14px;
  color: #0a1f44;
  margin-bottom: 4px;
  text-transform: capitalize;
`;

export const FormButton = styled(Grid)`
  padding-top: 16px;
`;

export const FormValidationMessage = styled.div`
  box-sizing: border-box;
  width: 100%;
  color: #f44336;
  padding: 3px 14px 0;
  font-size: 12px;
  margin-top: 3px;
  font-weight: 400;
  text-align: center;
`;

export const FormHeading = styled(Typography)`
  margin: 0;
  color: #0a1f44;
  letter-spacing: 0.065em;
  font-weight: bold;
  font-size: 20px;
`;

export const FormSubtitle = styled(Typography)`
  margin: 6px 0 0;
  max-width: 302px;
  color: #53627c;
  font-size: 13px;
  text-align: center;
  font-weight: normal;
`;

export const Footer = styled(Grid)`
  padding: 16px 16px 27px;
  margin-bottom: auto;

  ${media.greaterThan("sm")`
    padding: 24px 16px 24px;
  `}
`;

export const FooterBody = styled(Typography)`
  font-size: 13px;
`;
